import { Box, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Trans } from "@lingui/macro";
import React from "react";

interface MaximumInfoProps {
  maximum: number;
}

const MaximumInfo: React.FC<MaximumInfoProps> = ({ maximum }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        borderTop: "1px solid #eee",
        borderBottom: "1px solid #eee",
        mt: 6,
        py: 1,
      }}
    >
      <InfoIcon />
      <Typography className="text-sm leading-[18px] text-[#404647]">
        <Trans>{`This product has a maximum quantity of ${maximum}`}</Trans>
      </Typography>
    </Box>
  );
};
export default React.memo(MaximumInfo);
